import styles from "./TraitsHeading.module.css";

export default function TraitsHeading(props: { title: string }) {
  return <h2 className={styles.heading}>{props.title}</h2>;
}
